// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.leadmanagement.type.SatelliteLeadManagementSourceType

export enum SatelliteLeadManagementSourceType {
  STREET_EASY = 'STREET_EASY',
  ZILLOW_RENTAL_NETWORK = 'ZILLOW_RENTAL_NETWORK',
}

export const SatelliteLeadManagementSourceType_values = [
  SatelliteLeadManagementSourceType.STREET_EASY,
  SatelliteLeadManagementSourceType.ZILLOW_RENTAL_NETWORK,
] as const;
